import { Component, OnInit, OnDestroy, Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { TextTools } from 'appshared/text-tools';
import { MiscTools } from 'appshared/misc-tools';

import { AuthService } from 'client/app/services/auth.service';
import { UiAlertsService } from 'client/app/components/ui-alerts/ui-alerts.service';

import { PagingSearchBarComponent } from 'client/app/components/shared/paging-search-bar/paging-search-bar.component';

@Component({
	selector: 'app-table-logs',
	templateUrl: './table-logs.component.html',
	styleUrls: ['./table-logs.component.scss']
})
export class TableLogsComponent implements OnInit {
	ac = AppConstants;
	// tt = TextTools;
	// mt = MiscTools;

	@ViewChild(PagingSearchBarComponent) pagingSearchBar: PagingSearchBarComponent = null;

	/*
		pass in logs
			- storageKey
		options
			- showUserInfo : true
			- showObjectInfo: true
			- linkObject: true
			- linkUser: false
	
	*/

	@Input() expandNames?: boolean = true;

	authUser: Models.AuthUser = null;
	loading: boolean = false;

	displayOptions: Models.TableDisplayOptions = new Models.TableDisplayOptions();
	pagingOptions: Models.TablePagingOptions = new Models.TablePagingOptions();
	storageKey: string = '';

	showUserInfo: boolean = true;
	showObjectInfo: boolean = true;
	linkObject: boolean = true;
	linkUser: boolean = false;

	items: Models.AdminLog[] = [];
	itemsToShow: Models.AdminLog[] = [];


	columnDefs: Models.ColumnDefinition[] = [
		{
			field: 'added_on',
			type: 'baseDate',
			sortType: 'numeric',
			label: 'Date/Time',
			toolTip: null,
			icon: null
		}, {
			field: '__username',
			type: 'baseText',
			sortType: 'text',
			label: 'User',
			toolTip: null,
			icon: null
		}, {
			field: 'obj_type',
			type: 'baseText',
			sortType: 'text',
			label: 'Type',
			toolTip: null,
			icon: null
		}, {
			field: 'obj_name',
			type: 'baseText',
			sortType: 'text',
			label: 'Object',
			toolTip: null,
			icon: null
		}, {
			field: 'action',
			type: 'baseText',
			sortType: 'text',
			label: 'Action',
			toolTip: null,
			icon: null
		}, {
			field: 'information',
			type: 'baseText',
			sortType: 'text',
			label: 'Information',
			toolTip: null,
			icon: null
		}
	];

	fieldsToShow: string[] = [];
	allFieldsToShow: string[] = [];
	lockedFields: string[] = [];
	baselineFields: string[] = [];
	minimalFields: string[] = [];

	// ------------------------------------------------------------------------
	constructor(
		private router: Router,
		private uiAlertsService: UiAlertsService,
		private authService: AuthService) {
	}

	// ------------------------------------------------------------------------
	ngOnInit(): void {
		const sessionUser: Models.AuthUser = this.authService.getUser();
		if (sessionUser != null && sessionUser.id !== 0) {
			this.authUser = sessionUser;
			this.setups();
		} // if
	}

	// ------------------------------------------------------------------------
	async setups() {

	}

	// ------------------------------------------------------------------------
	updateContent(items: Models.AdminLog[], storageKey: string, options: any = {}) {
		this.loading = true;

		this.items = items;
		this.storageKey = storageKey;

		let optionKeys: string[] = [];
		if (options) optionKeys = Object.keys(options);

		if (optionKeys.includes('showUserInfo')) this.showUserInfo = options.showUserInfo;
		if (optionKeys.includes('showObjectInfo')) this.showObjectInfo = options.showObjectInfo;
		if (optionKeys.includes('linkObject')) this.linkObject = options.linkObject;
		if (optionKeys.includes('linkUser')) this.linkUser = options.linkUser;

		this.fieldsToShow = [];
		this.allFieldsToShow = [];
		this.lockedFields = [];
		this.baselineFields = [];
		this.minimalFields = [];
		this.fieldsToShow.push('added_on');
		if (this.showUserInfo) this.fieldsToShow.push('__username');
		if (this.showObjectInfo) {
			this.fieldsToShow.push('obj_type');
			this.fieldsToShow.push('obj_name');
		} // if
		this.fieldsToShow.push('action');
		this.fieldsToShow.push('information');

		for (const item of this.items) {
			item['__username'] = TextTools.parseUserInfo(item.user_info);
			item['__usernameToShow'] = TextTools.chopString(item['__username'], 25);
			item['__niceType'] = TextTools.niceLogType(item.obj_type);
			item['__niceAction'] = TextTools.niceLogAction(item.action);
			item['__route'] = MiscTools.getRoute(item.obj_type, item.action, item.obj_id);
			item['__objNameToShow'] = TextTools.chopString(item.obj_name, 30);

			item['__authIcon'] = null;
			item['__authMode'] = null;
			for (const authMode in AppConstants.authModeIcons) {
				if (item.user_info.includes('[' + authMode + ']')) {
					item['__authIcon'] = AppConstants.authModeIcons[authMode];
					item['__authMode'] = authMode;
				} // if
			} // for


		} // for

		this.pagingSearchBar.setupPaging(this.items, this.columnDefs, this.storageKey, 'added_on', 'desc');


		this.loading = false;
	} // updateContent

	// --------------------------------------------------------------------
	copyToClipboardAlert(item: string = '') {
		this.uiAlertsService.copyToClipboardAlert(item);
	}

	// ------------------------------------------------------------------------
	filterItems(matchWords: string[]): any[] {

		const tmpList: Models.AdminLog[] = [];
		for (const item of this.items) {
			let match: boolean = true;
			if (matchWords.length > 0) {
				let matches: number = 0;
				for (const w of matchWords) {
					if (item.action.toLowerCase().includes(w)
						|| item.information.toLowerCase().includes(w)
						|| (this.showUserInfo && item.user_info.toLowerCase().includes(w))
						|| (this.showObjectInfo && item.obj_type.toLowerCase().includes(w))
						|| (this.showObjectInfo && item.obj_name.toLowerCase().includes(w))
					)
						matches++;
				} // for
				if (matches !== matchWords.length) match = false;
			} // if

			if (match) tmpList.push(item);
		} // for

		return tmpList;
	} // filterItems

	// ------------------------------------------------------------------------
	setSortBy(field: string) {
		this.pagingSearchBar.setSortBy(field);
	} // setSortBy

	// ------------------------------------------------------------------------
	// Catch calls from the paging/search bar
	// ------------------------------------------------------------------------
	getParentMethod(): any {
		return {
			filterItems: (matchWords: string[]) => {
				return this.filterItems(matchWords);
			},
			updateItemsToShow: (itemsToShow: any[], displayOptions: Models.TableDisplayOptions, pagingOptions: Models.TablePagingOptions) => {
				this.itemsToShow = itemsToShow;
				this.displayOptions = displayOptions;
				this.pagingOptions = pagingOptions;
			},
			updateFieldsToShow: (fieldsToShow: string[]) => {
				this.fieldsToShow = fieldsToShow;
			},
			setPageNum: (pageNum: number, uniqueId: string) => {
				if (this.pagingSearchBar) this.pagingSearchBar.setPageNum(pageNum);
			},
			setSortBy: (field: string) => {
				this.setSortBy(field);
			}
		}
	}
}
